var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgModuleSequences(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.8628 22.8033L21.6346 29.0301C21.3882 29.2764 21.1595 29.7337 21.1067 30.0679L20.7724 32.4425C20.6493 33.3044 21.2475 33.9025 22.1096 33.7793L24.4848 33.4451C24.819 33.3924 25.2941 33.1637 25.5228 32.9174L31.7511 26.6907C32.8243 25.6177 33.3345 24.3688 31.7511 22.7858C30.1852 21.2203 28.936 21.7303 27.8628 22.8033Z",
    fill: "#D6D6FA",
    stroke: "#6467EF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9655 23.7004C27.4934 25.6001 28.9713 27.0777 30.8714 27.6054Z",
    fill: "#D6D6FA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9655 23.7004C27.4934 25.6001 28.9713 27.0777 30.8714 27.6054",
    stroke: "#6467EF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 33H12C6.75 33 4.5 30 4.5 25.5V9.75C4.5 5.25 6.75 2.25 12 2.25H24C29.25 2.25 31.5 5.25 31.5 9.75V17",
    stroke: "#6467EF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11 11L19 11",
    stroke: "#6467EF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11 19L25 19",
    stroke: "#6467EF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModuleSequences);
export default __webpack_public_path__ + "static/media/module-sequences.9642ded8.svg";
export { ForwardRef as ReactComponent };